import { LOCAL_STORAGE_KEYS as r } from "./constants30.mjs";
import { BaseStorageService as l } from "./BaseStorageService.mjs";
const c = {
  set: (e, t) => {
    localStorage.setItem(e, t);
  },
  get: (e) => localStorage.getItem(e),
  has: (e) => localStorage.getItem(e) !== null,
  delete: (e) => {
    localStorage.removeItem(e);
  },
  getAll: () => localStorage
};
class s extends l {
  clear = () => {
    localStorage.clear();
  };
  getEntries = (t = "") => {
    const a = [];
    for (const o of Object.keys(localStorage))
      o?.startsWith(t) && a.push({ key: o, value: localStorage.getItem(o) });
    return a;
  };
}
const g = Object.values(r.private), n = new s(
  c,
  g
);
export {
  n as LocalStorageService
};
//# sourceMappingURL=LocalStorageService.mjs.map
